module.exports = __webpack_public_path__ + "img/icon11.ad26a59b.png";